<template>
  <div>
    <h1 class="page-header">{{ $t('position.position') }}</h1>
    <div class="row">
      <div class="col-lg-3 col-md-5 col-sm-12">
        <ts-card>
          <ts-card-wrapper>
            <form-create
              @success_create="fetchData"
              :edit="edit_data"
              @success_update="edit_data = ''"
              @cancel="fetchData"
            ></form-create>
          </ts-card-wrapper>
        </ts-card>
      </div>
      <div class="col-lg-9 col-md-7 col-sm-12">
        <ts-card>
          <ts-card-wrapper class="d-flex justify-content-end">
            <ts-input
              v-model="search"
              :placeholder="$t('position.search')"
              style="width: 300px"
              class="kh-font"
            />
          </ts-card-wrapper>
          <ts-table :columns="columns" :records="resources" :loading="loading">
            <template slot-scope="{ record }">
              <td class="kh-font">{{ record.pos_name_kh }}</td>
              <td>{{ record.pos_name_en }}</td>
              <td>
                {{
                  record.position_level ? record.position_level.pos_level : ''
                }}
              </td>
              <td class="text-center">
                <span style="color: #55e157" v-if="record.is_active"
                  ><i class="fa fa-check"></i
                ></span>
              </td>
              <td class="text-center">
                <a
                  href="#"
                  v-tooltip="$t('edit')"
                  class="text-primary mr-2"
                  @click.prevent="edit(record)"
                  v-if="!is_hris"
                >
                  <i class="fas fa-edit"></i>
                </a>
                <a
                  href="#"
                  v-tooltip="$t('delete')"
                  class="text-danger"
                  @click.prevent="destroy(record.position_id)"
                  v-if="!is_hris"
                >
                  <i class="fas fa-trash"></i>
                </a>
              </td>
            </template>
          </ts-table>
          <ts-card-wrapper class="d-flex justify-content-end p-15">
            <ts-pagination v-model="pagination" @navigate="fetchData">
            </ts-pagination>
          </ts-card-wrapper>
        </ts-card>
      </div>
    </div>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import { mapState } from 'vuex'
import FormCreate from './form.vue'

export default {
  components: {
    FormCreate
  },
  name: 'position',
  props: ['editData'],
  data () {
    return {
      edit_data: this.editData,
      loading: false,
      columns: [
        { name: this.$t('position.nameKh') },
        { name: this.$t('position.nameEn') },
        { name: this.$t('position.level'), style: 'width: 5%' },
        { name: this.$t('position.active'), style: 'width: 2%' },
        {
          name: this.$t('position.actions'),
          style: 'width: 1px; text-align:center'
        }
      ]
    }
  },
  created () {
    this.fetchData()
  },
  computed: {
    ...mapState('position', ['resources', 'pagination']),
    search: {
      get () {
        return this.$store.state.position.search
      },
      set (newVal) {
        this.$store.commit('position/SET_SEARCH', newVal)
        this.$store.commit('position/RESET_CURRENT_PAGE')
      }
    },
    is_hris () {
      if (this.$store.state.authUser.company) {
        return this.$store.state.authUser.company.is_hris
      }
      return false
    }
  },
  methods: {
    fetchData (attributes) {
      this.loading = true

      this.$store
        .dispatch('position/fetch', attributes)
        .then(() => (this.loading = false))
        .catch(error => {
          this.$toasted.error(error.message)
          this.loading = false
        })
    },

    edit (data) {
      this.edit_data = data
      this.$router.push(`/positions/${data.position_id}`)
    },

    async destroy (id) {
      if (await this.$confirmModal.danger('Are you sure to delete ?')) {
        this.$store
          .dispatch('position/delete', id)
          .then(response => {
            this.$toasted.success(response.message)
            this.fetchData()
            this.$store.dispatch('position/getNewParentPostion')
          })
          .catch(error => {
            this.$toasted.error(error.message)
          })
      }
    }
  },
  watch: {
    search: debounce(function (search) {
      this.fetchData({ search })
    }, 500)
  },
  beforeRouteLeave (to, from, next) {
    if (_.isEmpty(to.params) && to.name != 'position-create') {
      this.$store.commit('position/RESET_STATE')
    }
    next()
  }
}
</script>
